import { render } from "./create-payroll.vue?vue&type=template&id=6bda494a&scoped=true"
import script from "./create-payroll.vue?vue&type=script&lang=js"
export * from "./create-payroll.vue?vue&type=script&lang=js"

import "./create-payroll.vue?vue&type=style&index=0&id=6bda494a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bda494a"]])

export default __exports__